















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({})
export default class BackgroundVideo extends Vue {
  @Prop({required: true})
  src!: string;

  @Prop({required: true})
  poster!: string;

  @Prop({default: 0})
  blur!: number;
}

